import React from 'react';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';

import { useCurrentTracklog, useMapControls } from 'ff/debrief/hooks';
import RouteIcon from 'ff/debrief/components/customIcons/RouteIcon';

const SnapToRouteButton = () => {
    const { viewport } = useCurrentTracklog();
    const { controls } = useMapControls();

    const handleClick = () => {
        controls.flyToBounds(viewport.bounds);
    };

    if (!viewport) return null;
    return (
        <Paper
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '32px',
                width: '32px',
                borderRadius: '4px',
            }}
        >
            <IconButton size="small" onClick={handleClick}>
                <RouteIcon sx={{ width: '16px', color: '#000000' }} />
            </IconButton>
        </Paper>
    );
};

export default SnapToRouteButton;
